import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TalwindcssBlock from 'components/Tailwindcss/Block';

const SelectBox = ({
  name,
  options,
  wrapperClassName,
  wrapper: Wrapper,
  label,
  onChange,
  value,
  onBlur,
  disabled,
}) => {
  return (
    <Wrapper className={classNames('mb-6', wrapperClassName)}>
      <label className="font-roboto text-xl mb-2 block">{label}</label>
      <div className="inline-block relative w-full">
        <TalwindcssBlock
          block
          appearance-none
          w-full
          bg-white={!disabled}
          bg-gray-200={disabled}
          custom-classname-x-2000={disabled}
          border
          border-brandblue
          px-4
          py-2
          pr-8
          rounded
          shadow
          leading-tight
          hover="border-gray-500"
          focus={['outline-none', 'shadow-outline']}
        >
          <select name={name} value={value} onChange={onChange} onBlur={onBlur} disabled={disabled}>
            {options.map(({ label, value }) => (
              <option key={value} value={String(value)}>
                {label}
              </option>
            ))}
          </select>
        </TalwindcssBlock>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg
            className="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </div>
      </div>
    </Wrapper>
  );
};

SelectBox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  wrapper: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func]),
  wrapperClassName: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

SelectBox.defaultProps = {
  wrapper: ({ children, className }) => <div className={className}>{children}</div>,
};

export default SelectBox;
